// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"354":"424f0300","763":"6c244bdb","838":"849b6b25"}[chunkId] + ".chunk.js");